import { render, staticRenderFns } from "./CourtOrderPetition.vue?vue&type=template&id=abb834b0&scoped=true&"
import script from "./CourtOrderPetition.vue?vue&type=script&lang=js&"
export * from "./CourtOrderPetition.vue?vue&type=script&lang=js&"
import style0 from "./CourtOrderPetition.vue?vue&type=style&index=0&id=abb834b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb834b0",
  null
  
)

export default component.exports